module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"EntryDisplay":{"englisch_label":"Englisch","opposite_label":"Gegenteil"}},"en":{"EntryDisplay":{"englisch_label":"English","opposite_label":"Opposite"}}}')
  delete Component.options._Ctor
}
